import { render, staticRenderFns } from "./RsaPazienteRefertiPage.vue?vue&type=template&id=0cef8e5e"
import script from "./RsaPazienteRefertiPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRefertiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports